// extracted by mini-css-extract-plugin
export default {"container":"LabeledSwitchComponent_container__H9Gim","lightcontainer":"LabeledSwitchComponent_lightcontainer__kwJHf","selected":"LabeledSwitchComponent_selected__wpZMt"};